import { snapshot } from 'valtio';
import { AppOwnerRoleType, AppOwnerType, OwnerForm } from 'common-types';
import AppOwnersStore from '../stores/app-owners-store';
import { validateOwnersFormList } from '../utils/aplications-owners-utils';

export const updateAssignAppOwnerRequest = (
  field: 'owners' | 'appIds' | 'roles',
  value: string[] | AppOwnerType[],
) => {
  const { assignAppOwnersRequest } = snapshot(AppOwnersStore);
  AppOwnersStore.assignAppOwnersRequest = {
    ...assignAppOwnersRequest,
    [field]: [...value],
  };
};

export const updateAppOwnerEditRequest = (
  field: 'role' | 'appId' | 'owners' | 'prevOwners',
  value: string | AppOwnerRoleType | AppOwnerType[],
) => {
  const { editAppOwnerRoleRequest } = snapshot(AppOwnersStore);
  AppOwnersStore.editAppOwnerRoleRequest = {
    ...editAppOwnerRoleRequest,
    [field]: field === 'owners' ? [...value] : value,
  };
};

export const resetAssignAppOwnerRequest = () => {
  AppOwnersStore.assignAppOwnersRequest = {
    owners: [],
    appIds: [],
    roles: [],
    ownersFormList: [],
  };
};

export const resetUpdateAppOwnerEditRequest = () => {
  AppOwnersStore.editAppOwnerRoleRequest = {
    prevOwners: [],
    owners: [],
    appId: null,
    role: null,
    ownersFormList: [],
  };
};

export const setDisplaySelectedAppOwners = (appOwners: string[]) => {
  AppOwnersStore.displaySelectedAppOwners = appOwners;
};

export const setOwnersFormList = (ownersFormList: OwnerForm[]) => {
  const validatedList = validateOwnersFormList(ownersFormList);
  AppOwnersStore.assignAppOwnersRequest.ownersFormList = validatedList;
  if (validatedList.some(o => o.invalidEmailMsg || o.invalidNameMsg)) {
    return validatedList;
  }
  AppOwnersStore.assignAppOwnersRequest.owners.push(
    ...ownersFormList.map(o => ({ name: o.name, email: o.email })),
  );
  return null;
};

export const setOwnersEditFormList = (ownersFormList: OwnerForm[]) => {
  const validatedList = validateOwnersFormList(ownersFormList);
  AppOwnersStore.editAppOwnerRoleRequest.ownersFormList = validatedList;

  if (validatedList.some(o => o.invalidEmailMsg || o.invalidNameMsg)) {
    return validatedList;
  }
  AppOwnersStore.editAppOwnerRoleRequest.owners.push(
    ...ownersFormList.map(o => ({ name: o.name, email: o.email })),
  );
  return null;
};
